import { hideModal } from '../core/bootstrap-helpers.js';
import { displayToastrAlert } from './toastr-alert.js';

export function resizeStickyContent() {
    const $stickyNavbar = $('.sticky-navbar');
    // Either delivery banner occupies the same slot below the navbar, so either one means the
    // 15px spacer is already accounted for. Samsara and Elite Extra are alternatives, but a
    // site mid-switch can have both settings present, so this tests for either rather than
    // assuming which one rendered.
    const $addMargin =
        $('#elite-extra-bar').length || $('#samsara-bar').length ? 0 : 15;

    if ($stickyNavbar.length) {
        const navbarHeight =
            $stickyNavbar.find('.navbar-wrapper').height() + $addMargin;
        $('#wrap').css('margin-top', `${navbarHeight}px`);
    }
}

export function buttonAnimation() {
    $(document).on(
        'click',
        '.btn:not(.btn-empty), #top-navbar .navbar-nav > li > a, #top-navbar-mobile .navbar-nav > li > a, #bottom-navbar .navbar-nav > li > a',
        function (e) {
            var $button = $(this);
            var $div = $('<div/>');
            var btnOffset = $(this).offset();
            var xPos = e.pageX - btnOffset.left;
            var yPos = e.pageY - btnOffset.top;

            $div.addClass('ripple-effect');
            var $ripple = $('.ripple-effect');

            $ripple.css('height', $(this).height());
            $ripple.css('width', $(this).height());

            $div.css({
                position: 'absolute',
                top: yPos,
                left: xPos,
            }).appendTo($(this));

            setTimeout(function () {
                if ($button.find('.ripple-effect').length) {
                    $button.find('.ripple-effect').remove();
                }
            }, 1000);
        }
    );
}

export function ajaxAlert(element, message) {
    if (element.length && message.length > 0) {
        element.html(
            '<div class="alert alert-success alert-dismissible" role="alert"><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
                message +
                '</div>'
        );

        setTimeout(function () {
            element.find('.alert').fadeOut(function () {
                element.empty();
                var $modal = element.closest('.modal');
                hideModal($modal);

                if (!$modal.find('form').hasClass('order-modal-form')) {
                    $modal.find('[type="submit"]').removeAttr('disabled');
                }
            });
        }, 3000);
    }
}

/**
 * Standard $.ajax error handler. Every ordering and admin call used to omit one, so
 * a network failure or a 500 left the UI looking like it had succeeded (#212).
 *
 * Pass to $.ajax as `error: ajaxError('Could not save the order name')`.
 * The optional onError runs after the toast, for callers that need to undo an
 * optimistic DOM change.
 */
export function ajaxError(message, onError) {
    return function (jqXHR, textStatus, errorThrown) {
        // an aborted request is not a failure worth telling anyone about
        if (textStatus === 'abort') {
            return;
        }

        console.error(message, textStatus, errorThrown, jqXHR && jqXHR.status);
        displayToastrAlert('error', message);

        if (typeof onError === 'function') {
            onError(jqXHR, textStatus, errorThrown);
        }
    };
}
